import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SiaRadarService {
  finalSelectionChanged: Subject<any> = new Subject();
  selectionChanged: Subject<any> = new Subject();
  selectionMode = signal<{ [key: string]: 'single' | 'multiple' }>({});

  constructor() {}

  finalSelectionChanged$() {
    return this.finalSelectionChanged.asObservable();
  }

  selectionChanged$() {
    return this.selectionChanged.asObservable();
  }

  setSelectionMode(guid: string, mode: 'single' | 'multiple') {
    this.selectionMode.update((prev) => {
      return {
        ...prev,
        [guid]: mode,
      };
    });
  }

  getSelectionMode(guid: string) {
    return this.selectionMode()[guid];
  }
}
